import { atom } from "recoil";
import { components } from "../../types/swagger-types";

export const applicationInfoState = atom<
  components["schemas"]["ApplicationInformation"]
>({
  key: "applicationInfoState",
  default: {},
});
